import { render, staticRenderFns } from "./CustomerAdditionalInfo.vue?vue&type=template&id=21376d1a"
import script from "./CustomerAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./CustomerAdditionalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports